import { fireMediaCardEvent, getRenderSucceededEventPayload, getRenderErrorEventPayload, getRenderFailedFileStatusPayload, getErrorEventPayload, getDownloadSucceededEventPayload, getDownloadFailedEventPayload } from '../utils/analytics';
import { MediaCardError } from '../errors';
export var fireOperationalEvent = function fireOperationalEvent(createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability) {
  var error = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new MediaCardError('missing-error-data');
  var traceContext = arguments.length > 6 ? arguments[6] : undefined;
  var metadataTraceContext = arguments.length > 7 ? arguments[7] : undefined;
  var fireEvent = function fireEvent(payload) {
    return fireMediaCardEvent(payload, createAnalyticsEvent);
  };
  switch (status) {
    case 'complete':
      fireEvent(getRenderSucceededEventPayload(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext));
      break;
    case 'failed-processing':
      fireEvent(getRenderFailedFileStatusPayload(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext));
      break;
    case 'error':
      fireEvent(getRenderErrorEventPayload(fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext));
      break;
  }
};
export var fireNonCriticalErrorEvent = function fireNonCriticalErrorEvent(createAnalyticsEvent, cardStatus, fileAttributes, ssrReliability) {
  var error = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new MediaCardError('missing-error-data');
  var traceContext = arguments.length > 5 ? arguments[5] : undefined;
  var metadataTraceContext = arguments.length > 6 ? arguments[6] : undefined;
  var errorPayload = getErrorEventPayload(cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext);
  fireMediaCardEvent(errorPayload, createAnalyticsEvent);
};
export var fireDownloadSucceededEvent = function fireDownloadSucceededEvent(createAnalyticsEvent, fileAttributes, traceContext, metadataTraceContext) {
  var payload = getDownloadSucceededEventPayload(fileAttributes, traceContext, metadataTraceContext);
  fireMediaCardEvent(payload, createAnalyticsEvent);
};
export var fireDownloadFailedEvent = function fireDownloadFailedEvent(createAnalyticsEvent, fileAttributes) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new MediaCardError('missing-error-data');
  var traceContext = arguments.length > 3 ? arguments[3] : undefined;
  var metadataTraceContext = arguments.length > 4 ? arguments[4] : undefined;
  var payload = getDownloadFailedEventPayload(fileAttributes, error, traceContext, metadataTraceContext);
  fireMediaCardEvent(payload, createAnalyticsEvent);
};